// 导入必要的依赖
import { useState, useEffect, useCallback } from 'react';
import apiExtension from './api_extension';
import './VocabularyPractice.css';

// 创建样式标签
const createStyles = () => {
  const styleId = 'qa-scene-learning-cn-to-en-styles';
  
  // 检查是否已存在样式
  if (document.getElementById(styleId)) {
    return;
  }
  
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    /* 场景化问答学习（中到英）专用样式 */
    .qa-card-container {
      margin-top: 20px;
    }
    
    .audio-url-hint {
      font-size: 12px;
      color: #666;
      margin-left: 5px;
    }
    
    .audio-url-hint.small {
      font-size: 10px;
    }
    
    .header {
      text-align: center;
      margin-bottom: 30px;
    }
    
    .header h2 {
      color: #333;
      margin-bottom: 10px;
    }
    
    .header .description {
      color: #666;
      font-size: 16px;
    }
    
    .filter-section {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      margin-bottom: 20px;
      padding: 15px;
      background-color: #f9f9f9;
      border-radius: 8px;
    }
    
    .filter-group {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    
    .filter-group label {
      font-weight: bold;
      color: #333;
      min-width: 80px;
    }
    
    .filter-select {
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 4px;
      background-color: white;
      cursor: pointer;
      min-width: 200px;
    }
    
    .filter-select:disabled {
      background-color: #f5f5f5;
      cursor: not-allowed;
    }
    
    .qa-card {
      background-color: white;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      padding: 20px;
      margin-bottom: 20px;
    }
    
    .qa-progress {
      text-align: right;
      font-size: 14px;
      color: #666;
      margin-bottom: 15px;
    }
    
    .qa-section {
      margin-bottom: 25px;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;
    }
    
    .qa-section:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
    
    .qa-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
    }
    
    .qa-header h3 {
      color: #333;
      margin: 0;
    }
    
    .qa-actions {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    
    .action-button {
      padding: 6px 12px;
      border: 1px solid #ddd;
      border-radius: 4px;
      background-color: white;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s ease;
    }
    
    .action-button:hover:not(:disabled) {
      background-color: #f0f0f0;
      border-color: #bbb;
    }
    
    .action-button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    
    .action-button.small {
      padding: 4px 8px;
      font-size: 14px;
    }
    
    .action-button.playing {
      background-color: #e3f2fd;
      border-color: #90caf9;
    }
    
    .qa-content {
      line-height: 1.6;
    }
    
    .qa-text {
      padding: 10px;
      border-radius: 4px;
      margin-bottom: 10px;
    }
    
    .chinese-text {
      background-color: #f1f8e9;
      color: #2e7d32;
      border-left: 3px solid #4caf50;
      text-align: left;
    }
    
    .english-text {
      background-color: #e3f2fd;
      color: #1565c0;
      border-left: 3px solid #2196f3;
      text-align: left;
    }
    
    .chinese-text.small,
    .english-text.small {
      font-size: 14px;
      padding: 8px;
      text-align: left;
    }
    
    .qa-remark {
      margin-top: 15px;
      padding: 10px;
      background-color: #fff3e0;
      border-left: 3px solid #ff9800;
      border-radius: 4px;
      color: #e65100;
    }
    
    .answers-list {
      margin-top: 15px;
    }
    
    .answer-item {
      margin-bottom: 15px;
      padding: 10px;
      background-color: #fafafa;
      border-radius: 4px;
      transition: background-color 0.2s ease;
    }
    
    .answer-item:hover {
      background-color: #f5f5f5;
    }
    
    .answer-content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 8px;
    }
    
    .answer-actions {
      margin-left: 10px;
    }
    
    .no-answers {
      text-align: center;
      color: #999;
      font-style: italic;
      padding: 20px;
    }
    
    .navigation-controls {
      display: flex;
      justify-content: center;
      gap: 20px;
      margin-top: 20px;
    }
    
    .nav-button {
      padding: 10px 20px;
      border: 1px solid #ddd;
      border-radius: 4px;
      background-color: white;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s ease;
    }
    
    .nav-button:hover:not(:disabled) {
      background-color: #f0f0f0;
      border-color: #bbb;
    }
    
    .nav-button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    
    .empty-state {
      text-align: center;
      color: #999;
      font-style: italic;
      padding: 50px 20px;
    }
    
    .loading-container {
      text-align: center;
      padding: 50px 20px;
    }
    
    .loading-spinner {
      display: inline-block;
      width: 40px;
      height: 40px;
      border: 3px solid #f3f3f3;
      border-top: 3px solid #3498db;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 15px;
    }
    
    .error-container {
      text-align: center;
      padding: 50px 20px;
      color: #e74c3c;
    }
    
    .error-message {
      margin-bottom: 20px;
    }
    
    .retry-button {
      padding: 10px 20px;
      border: 1px solid #e74c3c;
      border-radius: 4px;
      background-color: white;
      color: #e74c3c;
      cursor: pointer;
      transition: all 0.3s ease;
    }
    
    .retry-button:hover {
      background-color: #e74c3c;
      color: white;
    }
    
    .footer {
      margin-top: 30px;
      text-align: center;
      color: #666;
      font-size: 14px;
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    @keyframes pulse {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }
    
    /* 响应式设计 */
    @media (max-width: 768px) {
      .filter-section {
        flex-direction: column;
        align-items: flex-start;
      }
      
      .filter-group {
        width: 100%;
      }
      
      .filter-select {
        width: 100%;
      }
      
      .qa-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
      }
      
      .qa-actions {
        width: 100%;
        justify-content: flex-start;
      }
    }
    
    @media (max-width: 480px) {
      .qa-card {
        padding: 15px;
      }
      
      .navigation-controls {
        flex-direction: column;
        gap: 10px;
      }
      
      .nav-button {
        width: 100%;
      }
    }
  `;
  
  document.head.appendChild(style);
};

// 音频播放Hook
const useAudioPlayer = () => {
  const [audio] = useState(() => new Audio());
  const [currentPlayingAudio, setCurrentPlayingAudio] = useState(null);
  const [audioError, setAudioError] = useState(null);

  // 处理音频URL
  const processAudioUrl = useCallback((url) => {
    if (!url) return null;
    // 如果URL已包含完整路径，则直接返回
    if (url.startsWith('http')) {
      return url;
    }
    // 否则，添加基础URL
    return `${process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000'}${url}`;
  }, []);

  // 播放音频
  const playAudio = useCallback(async (audioUrl) => {
    if (!audioUrl) return;

    try {
      // 停止当前播放的音频
      if (audio.src) {
        audio.pause();
        audio.src = '';
      }

      const processedUrl = processAudioUrl(audioUrl);
      audio.src = processedUrl;
      setCurrentPlayingAudio(processedUrl);
      setAudioError(null);

      // 播放音频
      await audio.play();

      // 音频播放结束时重置状态
      audio.onended = () => {
        setCurrentPlayingAudio(null);
      };
    } catch (error) {
      console.error('音频播放失败:', error);
      setAudioError(`播放失败: ${error.message}`);
      setCurrentPlayingAudio(null);
    }
  }, [audio, processAudioUrl]);

  // 组件卸载时停止音频
  useEffect(() => {
    return () => {
      if (audio.src) {
        audio.pause();
        audio.src = '';
      }
    };
  }, [audio]);

  // 清除音频错误
  const clearAudioError = useCallback(() => {
    setAudioError(null);
  }, []);

  // 检查音频是否正在播放
  const isAudioPlaying = useCallback((audioUrl) => {
    if (!audioUrl || !currentPlayingAudio) return false;
    return processAudioUrl(audioUrl) === currentPlayingAudio;
  }, [currentPlayingAudio, processAudioUrl]);

  return {
    playAudio,
    clearAudioError,
    isAudioPlaying,
    audioError,
    currentPlayingAudio
  };
};

// 格式化场景数据为下拉选择所需的格式
const formatScenesForSelect = (scenes) => {
  const formatted = [];
  const processedSceneIds = new Set(); // 用于跟踪已处理的场景ID，防止重复
  
  // 先处理一级场景（无父场景）
  const rootScenes = scenes.filter(scene => scene && typeof scene === 'object' && !scene.parent);
  
  const recursiveFormat = (parentScene, depth = 0) => {
    // 校验parentScene是否为对象（避免无效数据）
    if (typeof parentScene !== 'object' || parentScene === null || !parentScene.id || !parentScene.name) {
      console.warn('跳过无效场景数据:', parentScene);
      return;
    }
    
    // 只添加未处理过的场景ID
    if (!processedSceneIds.has(parentScene.id)) {
      const indent = '　'.repeat(depth); // 中文空格，实现层级缩进
      formatted.push({
        id: parentScene.id,
        name: `${indent}${parentScene.name}`, // 显示层级（如“　娱乐”表示“采访类”的子场景）
        rawName: parentScene.name // 原始名称，用于显示
      });
      
      // 标记为已处理
      processedSceneIds.add(parentScene.id);
    }
    
    // 校验children是否为数组
    if (Array.isArray(parentScene.children) && parentScene.children.length > 0) {
      parentScene.children.forEach(child => recursiveFormat(child, depth + 1));
    }
  };
  
  rootScenes.forEach(scene => recursiveFormat(scene));
  return formatted;
};

// 中文到英文的场景化问答学习组件
const QaSceneLearningCnToEn = () => {
  // 创建样式
  useEffect(() => {
    createStyles();
  }, []);

  // 状态管理
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [scenes, setScenes] = useState([]);
  const [formattedScenes, setFormattedScenes] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [qaPairs, setQaPairs] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  
  // 筛选条件状态
  const [selectedSceneId, setSelectedSceneId] = useState('');
  const [selectedQuestionTypeId, setSelectedQuestionTypeId] = useState('');
  
  // 交互状态 - 默认显示中文，点击后显示英文
  const [currentQaState, setCurrentQaState] = useState({
    showAskEnglish: false,
    showAskRemark: false,
    showAnswerEnglish: [] // 存储每个答句是否显示英文的状态
  });
  
  // 音频播放Hook
  const { playAudio, clearAudioError, isAudioPlaying, audioError } = useAudioPlayer();

  // 1. 获取场景数据
  const fetchScenes = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await apiExtension.fetchWithAuth('/api/askandquestion/scenes/'); // 后端场景列表接口
      console.log('场景接口响应状态:', response.status);
      const data = await response.json();
      console.log('场景接口返回原始数据:', data);
      
      // 关键修复：适配后端分页结构
      const sceneList = Array.isArray(data.results) ? data.results : (Array.isArray(data) ? data : []);
      
      setScenes(sceneList); // 存储处理后的数组
      const formatted = formatScenesForSelect(sceneList);
      setFormattedScenes(formatted);
      console.log('获取场景成功，共', sceneList.length, '个场景');
    } catch (err) {
      setError(`场景数据加载失败: ${err.message}`);
      console.error('场景数据加载错误:', err);
      // 出错时显示空数据
      setScenes([]);
      setFormattedScenes([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // 2. 获取问句类型
  const fetchQuestionTypes = useCallback(async () => {
    try {
      const response = await apiExtension.fetchWithAuth('/api/askandquestion/question-types/');
      if (response.ok) {
        const data = await response.json();
        setQuestionTypes(data.results || []);
      } else {
        throw new Error('问句类型加载失败');
      }
    } catch (err) {
      setError(`问句类型加载失败: ${err.message}`);
      console.error('问句类型加载错误:', err);
    } finally {
      // 仅当两个API都调用完成时才设置loading为false
      if (scenes.length > 0) {
        setLoading(false);
      }
    }
  }, [scenes.length]);

  // 3. 获取单个问答对的完整数据（包含答句和问句详情）
  const fetchQaPairWithDetails = useCallback(async (qaPairId) => {
    try {
      const response = await apiExtension.fetchWithAuth(`/api/askandquestion/qa-pairs/${qaPairId}/`);
      if (response.ok) {
        const data = await response.json();
        
        // 处理答句数据
        let answers = [];
        if (data.answers && Array.isArray(data.answers)) {
          answers = data.answers.map(answer => ({
            ...answer,
            answer_pronunciation: answer.answer_pronunciation_url || answer.answer_pronunciation || ''
          }));
        }
        
        return {
          answers,
          ask_remark: data.ask_remark || ''
        };
      } else {
        throw new Error('问答对详情加载失败');
      }
    } catch (err) {
      console.error('问答对详情加载错误:', err);
      return { answers: [], ask_remark: '' };
    }
  }, []);

  // 4. 获取问答对列表
  const fetchQaPairs = useCallback(async () => {
    if (!selectedSceneId) return;
    
    setLoading(true);
    setError('');
    
    try {
      // 检查是否为场景11
      const isScene11 = selectedSceneId === 11 || String(selectedSceneId) === '11';
      
      // 步骤1：先查询当前场景的详情，确认是否为父场景（有子场景）
      let isParentScene = false;
      let childSceneIds = [];  // 存储子场景ID，用于调试
      try {
        const sceneDetailRes = await apiExtension.fetchWithAuth(`/api/askandquestion/scenes/${selectedSceneId}/`);
        if (sceneDetailRes.ok) {
          const sceneDetail = await sceneDetailRes.json();
          // 判断是否为父场景：有子场景且子场景数量>0
          isParentScene = sceneDetail.children && Array.isArray(sceneDetail.children) && sceneDetail.children.length > 0;
          // 提取子场景ID，用于日志调试
          childSceneIds = sceneDetail.children.map(child => child.id);
          console.log(`[父场景判定] 场景${selectedSceneId}详情：是否为父场景=${isParentScene}，子场景ID列表=${childSceneIds}`);
        }
      } catch (err) {
        console.warn(`[父场景判定] 查询场景${selectedSceneId}详情失败，默认按父场景处理`, err);
        isParentScene = true;  // 失败时默认按父场景处理，避免遗漏子场景
      }
      
      // 步骤2：构建查询参数（关键：父场景必加 include_descendants=true）
      const params = new URLSearchParams();
      params.append('scene', selectedSceneId);
      // 无论判定结果如何，强制添加 include_descendants=true（确保后端查询所有子场景）
      params.append('include_descendants', 'true');
      if (selectedQuestionTypeId) {
        params.append('question_type', selectedQuestionTypeId);
      }
      params.append('page_size', '1000');  // 加载足够多的数据
      
      // 步骤3：发送请求（后续逻辑不变）
      const apiUrl = `/api/askandquestion/qa-pairs/?${params.toString()}`;
      console.log(`[问答对请求] 最终参数：${params.toString()}，目标：查询场景${selectedSceneId}及其子场景${childSceneIds}的所有数据`);
      
      const requestTimestamp = new Date().toISOString();
      console.log(`[问答对请求] 发起请求 - 时间: ${requestTimestamp}, URL: ${apiUrl}, 场景ID: ${selectedSceneId}`);
      
      // 计时请求处理时间
      const startTime = performance.now();
      const response = await apiExtension.fetchWithAuth(apiUrl);
      const endTime = performance.now();
      
      const responseTimestamp = new Date().toISOString();
      console.log(`[问答对请求] 收到响应 - 时间: ${responseTimestamp}, 状态: ${response.status}, URL: ${apiUrl}, 响应时间: ${Math.round(endTime - startTime)}ms`);
      
      if (response.ok) {
          // 记录完整响应头信息，用于调试
          const responseHeaders = {};
          response.headers.forEach((value, key) => {
            responseHeaders[key] = value;
          });
          console.log(`[问答对请求] 响应头信息:`, responseHeaders);
          
          const data = await response.json();
          // 记录数据大小和基本结构
          const responseSize = JSON.stringify(data).length;
          const hasResults = data.hasOwnProperty('results') && Array.isArray(data.results);
          const resultCount = hasResults ? data.results.length : 0;
          console.log(`[问答对请求] 数据解析完成 - 数据大小: ${responseSize} 字节, 包含results数组: ${hasResults}, results长度: ${resultCount}`);
          
          // 场景11特定的调试信息
          if (isScene11) {
            console.log(`[场景11调试] 响应详情 - 完整数据结构:`, data);
            console.log(`[场景11调试] 响应详情 - 数据键列表:`, Object.keys(data));
            if (data.results) {
              console.log(`[场景11调试] 响应详情 - results类型:`, typeof data.results);
              console.log(`[场景11调试] 响应详情 - results数组检查:`, Array.isArray(data.results));
            }
          }
          
          console.log(`[问答对请求] 完整响应结构:`, data);
          
          let qaPairList = data.results || [];
        
        // 确保qaPairList是数组
        if (!Array.isArray(qaPairList)) {
          console.warn('问答对数据不是标准格式，尝试提取有用数据');
          qaPairList = [];
        }
        
        // 调试日志：确认返回数据是否包含子场景的问答对
        console.log(`[问答对请求] 场景${selectedSceneId}查询结果：共${qaPairList.length}条问答对`);
        if (qaPairList.length > 0) {
          // 打印前3条数据的场景ID，确认是否包含子场景数据
          qaPairList.slice(0, 3).forEach(pair => {
            console.log(`[数据示例] 问答对ID=${pair.id}，关联场景ID=${pair.scene_id || pair.scene?.id || pair.scene}`);
          });
        }
        
        // 增强数据处理：适配models.py中定义的字段结构和API实际返回格式
        const processedQaPairs = qaPairList.map(pair => {
          // 从模型和API分析：
          // 1. 问句音频字段在API中是ask_pronunciation_url
          // 2. 确保所有核心字段都有默认值
          
          // 处理问句音频字段映射
          const askPronunciation = pair.ask_pronunciation_url || pair.ask_pronunciation || '';
          
          // 处理核心字段默认值，特别增强ask_remark的处理
          let askRemark = '';
          if (pair.hasOwnProperty('ask_remark')) {
            askRemark = pair.ask_remark || '';
          } else if (pair.hasOwnProperty('remark')) {
            // 兼容可能的其他命名方式
            askRemark = pair.remark || '';
          }
          
          return {
            ...pair,
            // 确保问句核心字段都有默认值
            ask_english: pair.ask_english || '暂无英文问句',
            ask_chinese: pair.ask_chinese || '暂无中文翻译',
            ask_pronunciation: askPronunciation, // 使用处理后的音频URL
            ask_remark: askRemark, // 使用增强处理后的备注
            // 初始化空的answers数组，后续会通过专门的API获取
            answers: []
          };
        });
        
        // 场景11特定的数据处理日志
        if (isScene11) {
          console.log(`[场景11调试] 数据处理完成 - 处理前数量: ${qaPairList.length}, 处理后数量: ${processedQaPairs.length}`);
          if (processedQaPairs.length > 0) {
            console.log(`[场景11调试] 处理后第一条数据样例:`, {
              id: processedQaPairs[0].id,
              scene_id: processedQaPairs[0].scene_id,
              scene_name: processedQaPairs[0].scene_name,
              ask_english: processedQaPairs[0].ask_english,
              ask_chinese: processedQaPairs[0].ask_chinese
            });
          }
        }
        
        console.log(`[问答对请求] 数据处理完成 - 处理后问答对数量: ${processedQaPairs.length}, 场景ID: ${selectedSceneId}`);
        setQaPairs(processedQaPairs);
        setCurrentIndex(processedQaPairs.length > 0 ? 0 : -1); // 重置到第一个问答对
        
        // 添加空数据提示
        if (processedQaPairs.length === 0) {
          console.log(`[问答对请求] 场景 ${selectedSceneId} 未找到任何问答对数据`);
          // 简化错误信息，只显示"该场景下无数据"
          setError('该场景下无数据');
        } else {
          setError('');
        }
        
        // 如果有问答对，获取第一个问答对的完整数据（包含答句和问句详情）
        if (processedQaPairs.length > 0) {
          const firstQaPair = processedQaPairs[0];
          const detailedResponse = await apiExtension.fetchWithAuth(`/api/askandquestion/qa-pairs/${firstQaPair.id}/`);
          
          if (detailedResponse.ok) {
            const detailedData = await detailedResponse.json();
            
            // 处理答句数据
            let answers = [];
            if (detailedData.answers && Array.isArray(detailedData.answers)) {
              answers = detailedData.answers.map(answer => ({
                ...answer,
                answer_pronunciation: answer.answer_pronunciation_url || answer.answer_pronunciation || ''
              }));
            }
            
            // 更新问答对数据，同时包含问句备注信息
            setQaPairs(prev => prev.map(pair => 
              pair.id === firstQaPair.id ? {
                ...pair,
                answers,
                // 确保更新问句备注信息
                ask_remark: detailedData.ask_remark || pair.ask_remark || ''
              } : pair
            ));
          }
        }
      } else {
        // 提取错误详情，提供更具体的错误信息
        try {
          const errorData = await response.json();
          console.error(`[问答对请求] 失败详情:`, errorData);
          throw new Error(`问答对数据加载失败 (状态码: ${response.status}): ${errorData.detail || JSON.stringify(errorData)}`);
        } catch (jsonError) {
          // 如果无法解析JSON，使用基本错误信息
          throw new Error(`问答对数据加载失败 (状态码: ${response.status})`);
        }
      }
    } catch (err) {
      setError(`问答对加载失败: ${err.message}`);
      setQaPairs([]);
      setCurrentIndex(-1);
    } finally {
      setLoading(false);
    }
  }, [selectedSceneId, selectedQuestionTypeId]);

  // 5. 初始化加载：获取场景和问句类型
  useEffect(() => {
    fetchScenes();
    fetchQuestionTypes();
  }, [fetchScenes, fetchQuestionTypes]);

  // 6. 筛选条件变化时重新加载问答对
  useEffect(() => {
    // 延迟加载，避免频繁请求（用户快速切换下拉时）
    const timer = setTimeout(() => {
      fetchQaPairs();
    }, 500);
    return () => clearTimeout(timer);
  }, [selectedSceneId, selectedQuestionTypeId, fetchQaPairs]);

  // 确保第一级场景选择后立即刷新数据，避免延迟导致的参数丢失
  useEffect(() => {
    if (selectedSceneId) {
      // 立即执行一次，确保参数正确传递
      fetchQaPairs();
    }
  }, [selectedSceneId, fetchQaPairs]);

  // 监听qaPairs变化，用于调试
  useEffect(() => {
    console.log('qaPairs当前值:', qaPairs);
    // 检查qaPairs类型
    if (!Array.isArray(qaPairs)) {
      console.error('qaPairs类型错误，应为数组');
    }
  }, [qaPairs]);

  // 7. 浏览控制函数（上一个/下一个）
  const handlePrevQa = useCallback(() => {
    if (qaPairs.length === 0) return;
    const newIndex = currentIndex <= 0 ? qaPairs.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    
    // 重置当前问答对的交互状态
    setCurrentQaState({
      showAskEnglish: false,
      showAskRemark: false,
      showAnswerEnglish: []
    });
    
    // 获取新问答对的完整数据（包含答句和问句详情）
    const newQaPair = qaPairs[newIndex];
    if (newQaPair) {
      fetchQaPairWithDetails(newQaPair.id).then(details => {
        setQaPairs(prev => prev.map(pair => 
          pair.id === newQaPair.id ? {
            ...pair,
            answers: details.answers,
            // 确保更新问句备注信息
            ask_remark: details.ask_remark || pair.ask_remark || ''
          } : pair
        ));
      });
    }
  }, [qaPairs, currentIndex, fetchQaPairWithDetails]);

  const handleNextQa = useCallback(() => {
    if (qaPairs.length === 0) return;
    const newIndex = currentIndex >= qaPairs.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    
    // 重置当前问答对的交互状态
    setCurrentQaState({
      showAskEnglish: false,
      showAskRemark: false,
      showAnswerEnglish: []
    });
    
    // 获取新问答对的完整数据（包含答句和问句详情）
    const newQaPair = qaPairs[newIndex];
    if (newQaPair) {
      fetchQaPairWithDetails(newQaPair.id).then(details => {
        setQaPairs(prev => prev.map(pair => 
          pair.id === newQaPair.id ? {
            ...pair,
            answers: details.answers,
            // 确保更新问句备注信息
            ask_remark: details.ask_remark || pair.ask_remark || ''
          } : pair
        ));
      });
    }
  }, [qaPairs, currentIndex, fetchQaPairWithDetails]);

  // 8. 交互控制函数（切换英文显示/备注显示）
  const toggleAskEnglish = useCallback(() => {
    setCurrentQaState(prev => ({
      ...prev,
      showAskEnglish: !prev.showAskEnglish
    }));
  }, []);

  const toggleAskRemark = useCallback(() => {
    setCurrentQaState(prev => ({
      ...prev,
      showAskRemark: !prev.showAskRemark
    }));
  }, []);

  // 切换答句的英文显示
  const toggleAnswerEnglish = useCallback((answerIndex) => {
    setCurrentQaState(prev => {
      const newShowAnswerEnglish = [...prev.showAnswerEnglish];
      newShowAnswerEnglish[answerIndex] = !newShowAnswerEnglish[answerIndex];
      return {
        ...prev,
        showAnswerEnglish: newShowAnswerEnglish
      };
    });
  }, []);

  // 9. 获取当前问答对 - 确保索引有效
  const currentQaPair = qaPairs.length > 0 ? qaPairs[currentIndex >= 0 && currentIndex < qaPairs.length ? currentIndex : 0] : null;

  // 10. 重置所有状态（用于重新选择场景时）
  const resetState = useCallback(() => {
    setSelectedQuestionTypeId('');
    setQaPairs([]);
    setCurrentIndex(0);
    setCurrentQaState({
      showAskEnglish: false,
      showAskRemark: false,
      showAnswerEnglish: []
    });
  }, []);

  // 11. 场景选择变化时重置状态
  useEffect(() => {
    resetState();
  }, [selectedSceneId, resetState]);

  // 12. 渲染加载状态
  if (loading && (!scenes.length || !questionTypes.length)) {
    return (
      <div className="vocabulary-practice-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>加载场景和问句类型中...</p>
        </div>
      </div>
    );
  }

  // 13. 渲染错误状态
  if (error && error !== '该场景下无数据') {
    return (
      <div className="vocabulary-practice-container">
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button className="retry-button" onClick={() => {
            setError('');
            fetchScenes();
            fetchQuestionTypes();
            if (selectedSceneId) fetchQaPairs();
          }}>
            重试
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="vocabulary-practice-container">
      <div className="header">
        <h2>场景化问答学习（中到英）</h2>
        <p className="description">先显示中文，点击后查看英文，提升英语表达能力</p>
      </div>

      {/* 筛选条件区域 */}
      <div className="filter-section">
        <div className="filter-group">
          <label htmlFor="scene-select">选择场景：</label>
          <select
            id="scene-select"
            value={selectedSceneId}
            onChange={(e) => setSelectedSceneId(e.target.value)}
            disabled={loading}
            className="filter-select"
          >
            <option value="">-- 请选择场景 --</option>
            {formattedScenes.map(scene => (
              <option key={scene.id} value={scene.id}>
                {scene.name}
              </option>
            ))}
          </select>
        </div>

        {selectedSceneId && (
          <div className="filter-group">
            <label htmlFor="question-type-select">问句类型：</label>
            <select
              id="question-type-select"
              value={selectedQuestionTypeId}
              onChange={(e) => setSelectedQuestionTypeId(e.target.value)}
              disabled={loading}
              className="filter-select"
            >
              <option value="">所有问句类型</option>
              {questionTypes.map(type => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* 问答卡片区域 */}
      <div className="qa-card-container">
        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>加载问答数据中...</p>
          </div>
        ) : qaPairs.length === 0 ? (
          <div className="empty-state">
            {selectedSceneId ? (
              <p>{error || '该场景下无数据'}</p>
            ) : (
              <p>请选择场景和问句类型查看问答内容</p>
            )}
          </div>
        ) : currentQaPair ? (
          <>
            {/* 问答卡片 */}
            <div className="qa-card">
              {/* 当前进度 */}
              <div className="qa-progress">
                <span>{currentIndex + 1} / {qaPairs.length}</span>
              </div>

              {/* 问句部分 - 默认显示中文，点击后显示英文 */}
              <div className="qa-section question-section">
                <div className="qa-header">
                  <h3>问句</h3>
                  <div className="qa-actions">
                    <button
                      className={`action-button ${isAudioPlaying(currentQaPair.ask_pronunciation) ? 'playing' : ''}`}
                      onClick={() => playAudio(currentQaPair.ask_pronunciation)}
                      disabled={!currentQaPair.ask_pronunciation || !!audioError}
                      title="播放发音"
                    >
                      🎵
                    </button>
                    <span className="audio-url-hint">{currentQaPair.ask_pronunciation ? '有音频' : '无音频'}</span>
                    <button
                      className="action-button"
                      onClick={toggleAskEnglish}
                      title={currentQaState.showAskEnglish ? '隐藏英文' : '显示英文'}
                    >
                      {currentQaState.showAskEnglish ? '🇨🇳' : '🇬🇧'}
                    </button>
                    <button
                      className="action-button"
                      onClick={toggleAskRemark}
                      title={currentQaState.showAskRemark ? '隐藏备注' : '显示备注'}
                    >
                      💬
                    </button>
                  </div>
                </div>
                <div className="qa-content">
                  {/* 首先显示中文 - 添加点击事件以便点击任意中文部分显示英文 */}
                  <div 
                    className="qa-text chinese-text" 
                    onClick={toggleAskEnglish} 
                    style={{cursor: 'pointer'}}
                  >
                    {currentQaPair.ask_chinese || '暂无中文问句'}
                  </div>
                  {/* 点击后显示英文 */}
                  {currentQaState.showAskEnglish && (
                    <div className="qa-text english-text">
                      {currentQaPair.ask_english || '暂无英语问句'}
                    </div>
                  )}
                  {/* 增强的问句备注显示逻辑 */}
                  {currentQaState.showAskRemark && (
                    <div className="qa-remark" style={{textAlign: 'left'}}>
                      <p><strong>备注：</strong>
                        {currentQaPair.ask_remark && currentQaPair.ask_remark.trim() ? (
                          <span dangerouslySetInnerHTML={{ __html: currentQaPair.ask_remark }} />
                        ) : (
                          '暂无备注信息'
                        )}
                      </p>
                    </div>
                  )}
                  {audioError && (
                    <div className="qa-remark" style={{borderLeftColor: '#e74c3c', color: '#e74c3c'}}>
                      <p><strong>音频错误：</strong>{audioError}</p>
                      <button className="action-button small" onClick={clearAudioError} style={{marginTop: '10px'}}>
                        关闭提示
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* 答句部分 - 默认显示中文，点击后显示英文 */}
              <div className="qa-section answer-section">
                <div className="qa-header">
                  <h3>答句 ({currentQaPair.answers?.length || 0})</h3>
                </div>
                <div className="answers-list">
                  {Array.isArray(currentQaPair.answers) && currentQaPair.answers.length > 0 ? (
                    currentQaPair.answers.map((answer, index) => {
                      // 确保answer是对象
                      const validAnswer = typeof answer === 'object' && answer !== null ? answer : {};
                        
                      return (
                        <div key={validAnswer.id || index} className="answer-item">
                          <div className="answer-content">
                            {/* 首先显示中文 - 添加点击事件以便点击任意中文部分显示英文 */}
                            <div 
                              className="qa-text chinese-text" 
                              onClick={() => toggleAnswerEnglish(index)} 
                              style={{cursor: 'pointer'}}
                            >
                              {validAnswer.answer_chinese || '暂无中文答句'}
                            </div>
                            <div className="qa-actions answer-actions">
                              <button
                                className={`action-button small ${isAudioPlaying(validAnswer.answer_pronunciation) ? 'playing' : ''}`}
                                onClick={() => playAudio(validAnswer.answer_pronunciation)}
                                disabled={!validAnswer.answer_pronunciation || !!audioError}
                                title="播放发音"
                              >
                                🎵
                              </button>
                              <button
                                className="action-button small"
                                onClick={() => toggleAnswerEnglish(index)}
                                title={currentQaState.showAnswerEnglish[index] ? '隐藏英文' : '显示英文'}
                              >
                                {currentQaState.showAnswerEnglish[index] ? '🇨🇳' : '🇬🇧'}
                              </button>
                              <span className="audio-url-hint small">{validAnswer.answer_pronunciation ? '有音频' : '无音频'}</span>
                            </div>
                          </div>
                          {/* 点击后显示英文 */}
                          {currentQaState.showAnswerEnglish[index] && (
                            <div className="qa-text english-text small">
                              {validAnswer.answer_english || '暂无英语答句'}
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <p className="no-answers">暂无答句</p>
                  )}
                </div>
              </div>
            </div>

            {/* 浏览控制按钮 */}
            <div className="navigation-controls">
              <button className="nav-button" onClick={handlePrevQa} disabled={loading}>
                上一个
              </button>
              <button className="nav-button" onClick={handleNextQa} disabled={loading}>
                下一个
              </button>
            </div>
          </>
        ) : (
          <div className="empty-state">
            <p>没有找到匹配的问答内容</p>
          </div>
        )}
      </div>

      {/* 底部信息 */}
      <div className="footer">
        <p className="hint-text">提示：点击发音按钮播放语音，点击语言按钮切换中英文显示，点击问句备注按钮查看详细说明</p>
      </div>
    </div>
  );
};

export default QaSceneLearningCnToEn;